module.exports = __webpack_public_path__ + "img/grp-part-9-map.fe2cb266.png";